const request = {
    invalid_input: 'Girdi geçersiz. {{details}}',
    general: 'İstek hatası oluştu.',
    range_not_satisfiable: 'Aralık karşılanamıyor.',
    feature_not_supported: 'Bu özellik mevcut ortamda desteklenmiyor.',
};
export default Object.freeze(request);
